import { render, staticRenderFns } from "./vehicleboardassociation.vue?vue&type=template&id=352d9b06&scoped=true"
import script from "./vehicleboardassociation.vue?vue&type=script&lang=js"
export * from "./vehicleboardassociation.vue?vue&type=script&lang=js"
import style0 from "./vehicleboardassociation.vue?vue&type=style&index=0&id=352d9b06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d9b06",
  null
  
)

export default component.exports